/*
 * @Author: 18210594266 washqirui@163.com
 * @Date: 2022-11-25 16:20:08
 * @LastEditors: 18210594266 washqirui@163.com
 * @LastEditTime: 2022-12-01 14:23:33
 * @FilePath: \jutoujutou\jutou\current\frontend\jutou\src\views\mixins\dashboardMixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import API from '@/api/home.js';
import {mapState} from 'vuex'

const pageMixin = {
    data: function () {
        return {
            isPageAllowed:true,
            pageFields:[],
            pageFunc:[],
            pageSpecialFunc:[],
            allowedPlatList:[],//竞代权限数组 ovmi华
            pageLoading:false,
            platList: [],
        }
    },
    computed:{
        pageFieldsNames(){
            return this.pageFields.map(item=>item.name);
        },
        pageFuncNames(){
            return this.pageFunc.map(item=>item.name);
        },
        allowedPlatIds(){
            return  this.allowedPlatList.map(item=>item.id);
        },
        ...mapState({
            addRoutes: state => state.permission.addRoutes,
        }),
    },
    created: function () {
        this.getPageAllowAction();
    },
    methods:{
        getPageAllowAction(){
            let homeRoute = this.addRoutes.find(item=>item.name=='home')||{};
            let panelId = this.$route.meta.id;

            let navId = homeRoute.meta.id;
            if(navId){
                this.pageLoading = true;
                API.getPageAllowAction({
                    action_id:navId,
                }).then(res => {
                    this.pageLoading = false;
                    let resData = res.data||{};

                    let actionData = resData.page_action||[];
                    let platList = resData.plat_list||[];

                    if(platList.length>0){
                        /* 临时屏蔽爱奇艺、苹果 */
                        this.allowedPlatList = platList.filter(item=>+item.id<=7);
                        this.platList = platList
                    }

                    if(actionData.length<=0){
                        this.isPageAllowed = false;
                        this.pageFields = [];
                        this.pageFunc = [];
                        this.pageSpecialFunc = [];
                    }else{
                        this.isPageAllowed = true;
                        let actionPage = actionData.find(item=>item.id==panelId)||actionData[0];

                        this.pageFields = this._getFlatArray(actionPage.fields,[]);
                        this.pageFunc = actionPage.func;
                        this.pageSpecialFunc = actionPage.special_func;
                    }

                    /* initPageStates方法需要在宿主页面里定义后才能正确调用 */
                    if(this.initPageStates){
                        this.initPageStates();
                    }

                }, (err) => {
                    console.log('getPageAllowAction error', err);
                    this.isPageAllowed = false;
                    this.pageFields = [];
                    this.pageFunc = [];
                    this.pageSpecialFunc = [];
                    this.pageLoading = false;
                });
            }
        },
        _getFlatArray(list,result){
            list.forEach(item=>{
                if(!item.children){
                    result.push(item);
                }else if(item.children&&item.children.length>0){
                    return this._getFlatArray(item.children,result);
                }
            });
            return result;
        }
    }
};

export {
    pageMixin,
}
